import React, { useContext } from 'react';
import { ColumnsType, ColumnType } from 'antd/es/table';
import { Table } from '@maxtropy/components';
import { getColumns } from './columns';
import { EdgeDeviceTemplatePoint } from './index';
import { DataPointType } from '../../../../../types';
import { PointContext, PointContextProps } from '../../../../EdgeDevicePointInfo/contextTypes';
import { BatchEdgeContent } from '../../../contentTypes';
import { getUpdatePointParameters } from '../../../utils';

interface S7PointBaseProps {
  editColumns?: ColumnsType<EdgeDeviceTemplatePoint>;
  alterMode?: boolean;
}

const indexColumn: ColumnType<EdgeDeviceTemplatePoint> = {
  title: '序号',
  width: 70,
  fixed: 'left',
  render: (_, record, index) => index + 1,
};

const S7PointBase: React.FC<S7PointBaseProps> = props => {
  const { editColumns, alterMode } = props;

  const { dataSource, info } = useContext(PointContext) as PointContextProps<EdgeDeviceTemplatePoint>;
  const { baseForm } = useContext(BatchEdgeContent);
  let { parameter = [] } = baseForm?.getFieldsValue();
  parameter = getUpdatePointParameters(parameter, info?.driveType!);

  return (
    <Table
      sticky
      scroll={{ x: alterMode && parameter.length < 4 ? undefined : 1900, y: 500 }}
      rowKey="id"
      dataSource={dataSource?.filter(item => item.pointType === DataPointType.BASE_POINT)}
      columns={[indexColumn, ...getColumns(alterMode ? parameter : undefined, alterMode), ...(editColumns || [])]}
    />
  );
};

export default S7PointBase;
